//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconRatingHeartFill(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12 21.31C13.03 20.45 16.11 17.96 21.01 12.58C22.06 11.43 22.58 9.94005 22.49 8.39005C22.4 6.84005 21.71 5.43005 20.54 4.41005C18.51 2.64005 15.54 2.57005 13.42 4.08005C14.46 5.29005 14.93 5.85005 16.11 7.32005L14.55 8.58005C13.75 7.59005 11.56 5.00005 11.46 4.88005C9.36999 2.58005 5.76999 2.37005 3.42999 4.41005C1.04999 6.49005 0.829988 10.06 2.93999 12.55C6.36999 16.59 9.67999 19.34 12 21.31Z" fill="currentColor" /></svg>;
}
export default IconRatingHeartFill;